const fallbackReactionEmojis = {
  R0001: "\u{1F44D}",
  R0002: "\u{1F633}",
  R0003: "\u{1F602}",
  R0004: "\u{2764}\u{FE0F}",
  R0005: "\u{1F62E}",
  R0006: "\u{1F622}",
  R0007: "\u{1F64F}",
};

export const parseReactionMessage = (messageText = "", emojis = []) => {
  if (typeof messageText !== "string" || !messageText.trim()) {
    return null;
  }

  const match = messageText.match(/\b(R\d{4,})\b/);

  if (!match) {
    return null;
  }

  const reactionCode = match[1];
  const emoji = Array.isArray(emojis)
    ? emojis.find((item) => item?.Code === reactionCode)
    : null;
  const fallbackEmoji = fallbackReactionEmojis[reactionCode] || "\u{1F60A}";

  const [beforeCode, afterCode = ""] = messageText.split(reactionCode);
  const normalizedAfterCode = afterCode.replace(/"([^"]*)"/g, "$1");

  return {
    reactionCode,
    beforeCode,
    afterCode: normalizedAfterCode,
    emoji: emoji || {
      Code: reactionCode,
      Name: fallbackEmoji,
      Native: fallbackEmoji,
      Icon: "",
    },
  };
};
